<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmhead">Acknowledgements</h2>
<p class="noindent"><a id="page_viii">The author would like to extend his sincere thanks for the help in preparation of this book to the following individuals (in Russian alphabetical order): A. Arkhipov, M. Baryatinskiy, G. Gagin, M. Khairulin, A. Kirindas, M. Kolomiets, O. Leonov, M. Maslov, M. Muratov, G. Petrov, V. Rigmant, G. Sloutskiy, S. Chmelyuk, A. Yugenson and N. Yakubovich.</a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?03a8e309